import { leaderboardUsers } from "@/models/leaderboardUser.model";
import { brand } from "@/constants/brandVariables/brandVariables";
import { Box, Flex, Heading, Text } from "@radix-ui/themes";
import { FC, JSX } from "react";

import { formatGap } from "../../../../utils/formatRacingTime";
import LeaderboardItem from "../LeaderboardItem/LeaderboardItem";
import LatestResult from "../LatestResult/LatestResult";

const LeaderboardList: FC<{
  chasers: leaderboardUsers[];
  data: leaderboardUsers[];
}> = ({ chasers, data }): JSX.Element => {
  const rows = chasers.slice(0, brand.leaderboardLength);
  const leaderPoints = chasers[0]?.userChallengeData?.points;

  return (
    <Flex direction="column" gap="4" height="100%" minHeight="0">
      <Flex direction="column" gap="2" flexGrow="1" minHeight="0">
        <Flex align="center" justify="between" mb="1">
          <Heading as="h2" size="5" style={{ color: "white" }}>
            LEADERBOARD
          </Heading>
          <Text size="1" className="sr-list__legend">
            POS · DRIVER · LAP / GAP
          </Text>
        </Flex>

        <Box className="sr-list">
          {rows.map((user, i) => (
            <LeaderboardItem
              key={`ldbrd-${i}`}
              item={user}
              gap={formatGap(user.userChallengeData?.points, leaderPoints)}
            />
          ))}
        </Box>
      </Flex>

      <Box flexShrink="0">
        <Heading as="h3" size="3" weight="bold" className="gradient" mb="2">
          LATEST RESULT
        </Heading>
        <Box className="sr-latest">
          <LatestResult data={data} />
        </Box>
      </Box>
    </Flex>
  );
};

export default LeaderboardList;
